<div [formGroup]="timeEntryForm" class="form flex flex-col">
  <nx-edit-dateTime-input-v2
    [label]="'Zeitraum'"
    [placeholder]="'Zeitraum hizufügen'"
    class="dateTimeInput"
    formControlName="dateTime"
    [modifier]="'BETWEEN'"
    [precision]="'DATE_TIME'"
  ></nx-edit-dateTime-input-v2>
  <nx-edit-select-input
    formControlName="categoryId"
    placeholder="Kategorie hinzufügen"
    label="Kategorie"
    [options]="categoryOptions">
  </nx-edit-select-input>
  <div class="nx-edit-select">
    <label for="select">Pause</label>
    <p-dropdown
      #pauseTimeDropdown
      [panelStyle]="{'width': 'auto'}"
      (onClear)="$event.stopPropagation()"
      formControlName="pauseDuration"
      [appendTo]="'body'"
      [showClear]="true" 
      [editable]="true" 
      [options]="timeOptions"
      (onBlur)="onTimeBlur($event, 'pauseDuration')"
      [virtualScroll]="false"
      [filter]="false"
      [placeholder]="'hh:mm'"
      (onFocus)="onTimeFocus($event); pauseTimeDropdown.show()"
      class="pauseTimeDropdown"
      [panelStyleClass]="'nx-edit-select'"/>
      <small *ngIf="getPauseError()">{{getPauseError()}}</small>
  </div>
  <nx-edit-select-input
    formControlName="userId"
    placeholder="Nutzer hinzufügen"
    label="Nutzer"
    [options]="users">
  </nx-edit-select-input>
  <nx-textfield-input
    formControlName="note"
    placeholder="Notiz hinzufügen"
    label="Notiz"
    [rows]="2"/>
<div>